export var ProgramStep;
(function (ProgramStep) {
    ProgramStep["ABOUT"] = "about";
    ProgramStep["DETAILS"] = "details";
    ProgramStep["REVIEW"] = "review";
})(ProgramStep || (ProgramStep = {}));
export const FIELDS = [
    {
        field: 'schoolId',
        label: 'School/Institution',
        lookupCode: 'school_id',
        infoText: "Type the school name or select from the list. Enter 'Other' if your school is not found.",
        additionalInfo: 'School/Institution tooltip',
        description: 'Covered Schools. Your Employer has pre-approved a list of schools you may attend. If your school is not on the list, you may submit a request to add it.',
        required: true,
        showAllAtOnce: true,
        showSearchIcon: true,
    },
    {
        field: 'schoolName',
        label: 'Provider',
        infoText: '',
        additionalInfo: 'School/Institution tooltip',
        description: 'Name of the school or institution where you will be attending.',
        required: true,
    },
    {
        field: 'schoolCountryCode',
        label: 'School Country',
        infoText: '',
        description: 'The Country of the school or institution where you will be attending.',
    },
    {
        field: 'programLevelId',
        label: 'Expense Type',
        lookupCode: 'program_level_id',
        infoText: '',
        additionalInfo: 'Expense type tooltip',
        description: 'Program Level. This describes the level of education you are pursuing.',
        showAllAtOnce: true,
        required: true,
    },
    {
        field: 'programName',
        label: 'Program/Expense Name',
        infoText: '',
        additionalInfo: 'Program name tooltip',
        description: '',
        required: true,
    },
    {
        field: 'fieldOfStudyId',
        label: 'Field of Study',
        lookupCode: 'field_of_study_id',
        infoText: "Program's specific subject or focus area. Enter 'Other' if your field of study is not found.",
        alternateInfoText: "Program's specific subject or focus area.",
        additionalInfo: 'Field of study tooltip',
        alternateAdditionalInfo: 'Field of study tooltip - other disallowed',
        description: 'Title. This is the name of your program as listed on the school’s website or your receipt, if available.',
        required: true,
        showAllAtOnce: true,
    },
    {
        field: 'startDate',
        label: 'Initial start date',
        infoText: 'This is the date you first joined the program and might be earlier than the start date of your current term.',
        description: '',
        required: true,
    },
    {
        field: 'estCompDate',
        label: 'Estimated Completion Date',
        infoText: 'Date you expect to graduate or complete your program.',
        description: 'Completion. This is the date you expect to complete the entire program.',
        required: true,
    },
    {
        field: 'purpose',
        label: 'Purpose',
        infoText: 'Select all the reasons you are applying for this program.',
        description: '',
        options: [
            'It is required for my current role at {employerName}.',
            'It will qualify me for a new role at {employerName}.',
            'It will qualify me to change career fields.',
        ],
        required: true,
    },
    {
        field: 'documents',
        label: 'Documents',
        infoText: 'Upload one or more documents to help approve your program.',
        description: 'Program document details',
    },
    {
        field: 'description',
        label: 'Program Description',
        infoText: '',
        description: '',
    },
    {
        field: 'otherSchool',
        label: 'Other school/institution',
        infoText: '',
        description: '',
        required: true,
    },
    {
        field: 'otherSchoolCountryCode',
        label: 'Other school country',
        infoText: '',
        description: '',
        required: true,
    },
    {
        field: 'otherFieldOfStudy',
        label: 'Other field of study',
        infoText: 'Type the field of study',
        description: '',
        required: true,
    },
    {
        field: 'custom1',
        label: 'Select an option',
        lookupCode: 'pick_list',
        infoText: '',
        description: '',
        required: true,
        showAllAtOnce: true,
    },
    {
        field: 'isSingleExpense',
        label: 'Single Expense',
        infoText: '',
        description: '',
        required: true,
    },
];
export const FIELDS_BY_CODE = FIELDS.reduce((acc, field) => {
    acc[field.field] = field;
    return acc;
}, {});
export const ProgramStepFields = {
    [ProgramStep.ABOUT]: [
        'programLevelId',
        'schoolId',
        'schoolName',
        'fieldOfStudyId',
        'custom1',
        'programName',
        'description',
        'isSingleExpense',
    ].map(field => FIELDS.find(f => f.field === field)),
    [ProgramStep.DETAILS]: ['startDate', 'estCompDate', 'purpose'].map(field => FIELDS.find(f => f.field === field)),
    [ProgramStep.REVIEW]: [],
};
